/**
 * Gets the PSX vendor identifier based on VHR (Vehicle History Report) tile type.
 *
 * This utility function maps VHR tile types to their corresponding PSX vendor identifiers
 * for analytics tracking purposes. The type parameter is typically derived from a
 * vhrTile.tileType property.
 *
 * @param {string} type - The VHR tile type from vhrTile.tileType.
 */
export default function getPsxVendor(type) {
    switch (type) {
        case 'EXPERIAN_RETAIL':
        case 'EXPERIAN_APPENDED':
            return 'autocheckps';
        case 'CARFAX_RETAIL':
        case 'CARFAX_APPENDED':
            return 'carfaxps';
        default:
            return '';
    }
}
